// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Js_null_undefined from "@rescript/std/lib/es6/js_null_undefined.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

function card(json) {
  return {
          themeUid: Json_decode.field("theme_uid", Json_decode.string, json),
          themeImage: Json_decode.field("theme_image", Json_decode.string, json)
        };
}

function wallet(json) {
  return {
          cards: Json_decode.field("cards", (function (param) {
                  return Json_decode.array(card, param);
                }), json)
        };
}

function customer(json) {
  return {
          uid: Json_decode.field("uid", Json_decode.string, json),
          firstName: Json_decode.field("first_name", Json_decode.string, json),
          lastName: Json_decode.field("last_name", Json_decode.string, json),
          wallet: Json_decode.field("wallet", (function (param) {
                  return Json_decode.nullable(wallet, param);
                }), json)
        };
}

function safeDecodeCustomer(json) {
  var customer$1;
  try {
    customer$1 = customer(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return Js_null_undefined.fromOption(undefined);
    }
    throw exn;
  }
  return Js_null_undefined.fromOption(customer$1);
}

var Decode = {
  card: card,
  wallet: wallet,
  customer: customer,
  safeDecodeCustomer: safeDecodeCustomer
};

export {
  Decode ,
}
/* No side effect */
